import { render, staticRenderFns } from "./VehicleSelector.vue?vue&type=template&id=5935f0e8&scoped=true"
import script from "./VehicleSelector.vue?vue&type=script&lang=js"
export * from "./VehicleSelector.vue?vue&type=script&lang=js"
import style0 from "./VehicleSelector.vue?vue&type=style&index=0&id=5935f0e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5935f0e8",
  null
  
)

export default component.exports